import { render, staticRenderFns } from "./konfortify-review-grid.vue?vue&type=template&id=1f17c8b0&scoped=true&"
import script from "./konfortify-review-grid.vue?vue&type=script&lang=js&"
export * from "./konfortify-review-grid.vue?vue&type=script&lang=js&"
import style0 from "./konfortify-review-grid.vue?vue&type=style&index=0&id=1f17c8b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f17c8b0",
  null
  
)

export default component.exports